// src/services/collectionProductApi.js
// Servicio para manejar operaciones relacionadas con productos de colecciones

import { dotoniwoofApi } from '../api/dotoniwooApi';

// Los headers de autenticación se agregan automáticamente por el interceptor de axios

/**
 * Lista todos los productos de una colección
 * @param {number} collectionId - ID de la colección
 * @returns {Promise<Object>} Lista de productos
 */
export const getCollectionProducts = async (collectionId) => {
  try {
    console.log('Llamando a collectionProduct.php con ID:', collectionId);
    const response = await dotoniwoofApi.get(`/collectionProduct.php/${collectionId}`);
    
    console.log('Respuesta completa de collectionProduct.php:', response);
    console.log('Response status:', response.status);
    console.log('Response data:', response.data);
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener productos de colección:', error);
    console.error('Error response:', error.response);
    console.error('Error data:', error.response?.data);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Obtiene un producto específico de una colección
 * @param {number} collectionId - ID de la colección
 * @param {number} productId - ID del producto
 * @returns {Promise<Object>} Datos del producto
 */
export const getCollectionProductById = async (collectionId, productId) => {
  try {
    console.log('Llamando a getCollectionProductById:', { collectionId, productId });
    const response = await dotoniwoofApi.get(`/collectionProduct.php/${collectionId}/${productId}`);
    
    console.log('Respuesta de getCollectionProductById:', {
      status: response.status,
      data: response.data
    });
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener producto de colección:', error);
    console.error('Error response:', error.response);
    console.error('Error data:', error.response?.data);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Crea un nuevo producto en una colección
 * @param {number} collectionId - ID de la colección
 * @param {Object} productData - Datos del producto
 * @returns {Promise<Object>} Respuesta de la API
 */
export const createCollectionProduct = async (collectionId, productData) => {
  try {
    console.log('Enviando datos del producto:', productData);
    
    const response = await dotoniwoofApi.post(
      `/collectionProduct.php/${collectionId}`,
      productData
    );
    
    console.log('Respuesta del servidor:', response.data);
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al crear producto de colección:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Actualiza un producto de colección existente
 * @param {number} collectionId - ID de la colección
 * @param {number} productId - ID del producto
 * @param {Object} productData - Nuevos datos del producto
 * @returns {Promise<Object>} Respuesta de la API
 */
export const updateCollectionProduct = async (collectionId, productId, productData) => {
  try {
    console.log('Actualizando producto de colección:', collectionId, productId, productData);
    
    const response = await dotoniwoofApi.put(
      `/collectionProduct.php/${collectionId}/${productId}`,
      productData
    );
    
    console.log('Respuesta del servidor:', response.data);
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al actualizar producto de colección:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Elimina un producto de colección
 * @param {number} collectionId - ID de la colección
 * @param {number} productId - ID del producto
 * @returns {Promise<Object>} Respuesta de la API
 */
export const deleteCollectionProduct = async (collectionId, productId) => {
  try {
    const response = await dotoniwoofApi.delete(
      `/collectionProduct.php/${collectionId}/${productId}`
    );
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al eliminar producto de colección:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Agrega una imagen a un producto
 * @param {number} collectionId - ID de la colección
 * @param {number} productId - ID del producto
 * @param {Object} imageData - Datos de la imagen
 * @returns {Promise<Object>} Respuesta de la API
 */
export const addProductImage = async (collectionId, productId, imageData) => {
  try {
    const response = await dotoniwoofApi.post(
      `/collectionProduct.php/${collectionId}/${productId}/images`,
      imageData
    );
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al agregar imagen al producto:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Elimina una imagen de un producto
 * @param {number} collectionId - ID de la colección
 * @param {number} productId - ID del producto
 * @param {number} imageId - ID de la imagen
 * @returns {Promise<Object>} Respuesta de la API
 */
export const deleteProductImage = async (collectionId, productId, imageId) => {
  try {
    const response = await dotoniwoofApi.delete(
      `/collectionProduct.php/${collectionId}/${productId}/images`,
      {
        data: { action: 'delete', image_id: imageId }
      }
    );
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al eliminar imagen del producto:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};
